import { render, staticRenderFns } from "./Filiais.vue?vue&type=template&id=4a8a05da&scoped=true"
import script from "./Filiais.vue?vue&type=script&lang=js"
export * from "./Filiais.vue?vue&type=script&lang=js"
import style0 from "./Filiais.vue?vue&type=style&index=0&id=4a8a05da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8a05da",
  null
  
)

export default component.exports